export default __webpack_public_path__ + "static/media/bar.67fe2f47.svg";